// Light / dark / Auto, chosen per device. Auto follows the device (prefers-color-scheme).
// index.html applies the saved choice before first paint; this module changes it later.
// The colours themselves live in index.css as tokens.

export type ThemePref = "auto" | "light" | "dark";
const KEY = "gp_theme";

export function getThemePref(): ThemePref {
  try {
    const v = localStorage.getItem(KEY);
    return v === "light" || v === "dark" ? v : "auto";
  } catch {
    return "auto";
  }
}

export function applyTheme(pref: ThemePref): void {
  const root = document.documentElement;
  if (pref === "auto") root.removeAttribute("data-theme");
  else root.setAttribute("data-theme", pref);
}

export function setThemePref(pref: ThemePref): void {
  try {
    if (pref === "auto") localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, pref);
  } catch {
    // Storage blocked: the choice lasts for this page only.
  }
  applyTheme(pref);
}
